import React from 'react';
import styles from './index.module.scss';

export type Props = {
  fillColor?: string;
  className?: string;
  direction?: 'right' | 'left' | 'top' | 'bottom';
};

export const DoubleArrowIcon: React.FC<Props> = ({ fillColor = '#B4B8BE', className, direction = 'right' }) => {
  const directionClass = styles[direction] || styles.right;
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} ${directionClass}`}
    >
      <rect width="40" height="40" rx="20" fill="white" />
      <path d="M17.3333 26.6668L10.6666 20.0002" stroke={fillColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M17.3333 13.3333L10.6666 20" stroke={fillColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M24 26.6668L17.3333 20.0002" stroke={fillColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M24 13.3333L17.3333 20" stroke={fillColor} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
